import React from 'react';
import 'styles/loading.css';

const Loading: React.FC = () => {
  return (
    <div className='loading-page-container'>
      <div className='loading-page-spinner'>
        <div className='loading-page-spinner-inner'></div>
      </div>
      <div className='loading-page-text'>Chargement...</div>
    </div>
  );
};

export default Loading;
